module.exports = __webpack_public_path__ + "static/media/press_20130117_romeo.aa3b1afb.pdf";